<script>
  import { getSizedImageUrl } from "@shopify/theme-images";
  export let searchHit = {};

  const colorOptions = searchHit.options?.find(
    (option) => option.name === "Color"
  );
  const colorsCount = colorOptions
    ? colorOptions.values.length
    : searchHit.colors?.length || 0;
</script>

<a
  class="tw-cursor-pointer tw-flex tw-flex-col tw-whitespace-normal tw-relative"
  href={searchHit.onlineStoreUrl}
>
  <img
    loading="eager"
    class="tw-w-full tw-mb-2"
    src={getSizedImageUrl(searchHit.imageSrc, "300x")}
    alt={searchHit.title}
  />
  <div
    class="hover:tw-text-green-400 tw-w-full tw-mb-2 tw-font-serif tw-font-normal tw-text-base"
  >
    {searchHit.title}
  </div>
  {#if searchHit.sticker && searchHit.sticker.data && searchHit.sticker.data.text}
    <div
      class="tw-absolute tw-uppercase tw-top-1 tw-left-1 tw-text-xs tw-py-0.5 tw-rounded-full tw-tracking-wider tw-whitespace-nowrap tw-text-center tw-align-middle"
      style="color: {searchHit.sticker.data.color}; background-color:{searchHit
        .sticker.data.backgroundColor}; width:{searchHit.sticker.data
        .width}; font-family: Agrandir; font-weight: 500; font-size: 0.6rem; letter-spacing: 0.104rem; line-height: 0.6rem; padding: 6px 9px;"
    >
      {searchHit.sticker.data.text}
    </div>
  {/if}
  {#if colorsCount === 1}
    <div class="tw-text-sm">1 color</div>
  {:else if colorsCount > 0}
    <div class="tw-text-sm">{colorsCount} colors</div>
  {/if}
</a>
